import { Link, useLocation } from 'react-router';

import { cn } from '~/styles/extended-theme';
import { matchPaths } from '~/utils/match-paths';

export interface TabLinkProps {
  to: string;
  children: React.ReactNode;
  hasSubPaths?: boolean;
  className?: string;
}

export function TabLink({ to, children, className, hasSubPaths = false }: TabLinkProps) {
  const location = useLocation();
  const active = matchPaths(to, location.pathname, hasSubPaths);

  return (
    <Link
      to={to}
      className={cn(
        'border-b-2 border-black py-2 text-center font-mono text-button-medium uppercase',
        className,
        active ? 'border-secondary text-secondary' : undefined,
      )}
    >
      {children}
    </Link>
  );
}
